export const CLEAR_TIME_TABLE = 'CLEAR_TIME_TABLE';


// WEBPACK FOOTER //
// ./js/actions/Timetable.js